import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

interface StepIndicatorProps {
	currentStep: number;
	totalSteps: number;
}

export default function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
	return (
		<div className="flex items-center justify-center pt-6 px-6 pb-16">
			{[...Array(totalSteps)].map((_, index) => {
				const step = index + 1;
				const isCompleted = step < currentStep;
				const isCurrent = step === currentStep;

				return (
					<div key={step} className="flex items-center">
						<div className="flex flex-col items-center relative">
							<div
								className={cn(
									'size-10 rounded-full flex items-center justify-center text-lg font-semibold transition-colors duration-300',
									isCompleted
										? 'bg-green-500 text-white'
										: isCurrent
											? 'bg-blue-dark text-white ring-4 ring-blue-100'
											: 'bg-gray-200 text-gray-500',
								)}
							>
								{isCompleted ? <Check className="size-5" /> : step}
							</div>
							<span
								className={cn(
									'absolute -bottom-8 text-sm font-medium whitespace-nowrap hide-on-mobile',
									isCurrent ? 'text-blue-dark' : 'text-gray-400',
								)}
							>
								{step === 1 && 'Situatie'}
								{step === 2 && 'Gegevens'}
							</span>
						</div>
						{step < totalSteps && (
							<div className={cn('w-12 h-1 mx-2 rounded mr-3', step < currentStep ? 'bg-green-500' : 'bg-gray-200')} />
						)}
					</div>
				);
			})}
		</div>
	);
}
